import { api, handleResponse, handleError } from "./apiServices";
// api/subscription/merchant/create_checkout/64b51b8ac9c6798f4753cabc

export const create_checkout = (token, id, data) => {
  return api(token)
    .post(`api/subscription/merchant/create_checkout/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
};
export const success_subscription = (token, id) => {
  return api(token)
    .post(`/api/subscription/merchant/success_subscription/${id}`)
    .then(handleResponse)
    .catch(handleError);
};

export const cancel_subscription = (token, data) => {
  return api(token)
    .post(`/api/subscription/merchant/cancel_subscription`, data)
    .then(handleResponse)
    .catch(handleError);
};

export const startFreeTrail = token => {
  return api(token)
    .get(`/api/subscription/merchant/start_free_trial`)
    .then(handleResponse)
    .catch(handleError);
};

export const subscriptionHistoryData = (token, id, data) => {
  return api(token)
    .post(`/api/subscription/merchant/user/history/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
};

export const downloadInvoiceByID = (token, id) => {
  return api(token)
    .get(`/api/subscription/merchant/invoice/${id}`)
    .then(handleResponse)
    .catch(handleError);
};
